<template>
  <DBox
    :id="'cmp-catalog-products-royalty'"
    :addButton="false"
    :addLink="false"
    :addLinkLabel="$t('add_new_account')"
    @add_click="addAccountClick"
  >
    <div class="ut-fh">
      <NTable
        class="h2 c2 p0 dbox1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
        :id="'catalog-products-royalty_list'"
        height="170px"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('contract')">
              <span @click="onContractClick(item)" class="ut-link ut-text-accent5">{{ item["contract_name"] }}</span>
            </td>
            <td v-bind="tdcon('royalty_account')">
              <span  @click="onAccountClick(item)" class="ut-link ut-text-accent5">{{ item["calc_royalty_account_name"] }}</span>
            </td>
            <td v-bind="tdcon('rata')">
                <!-- <div class="keyvalue-container">
                  <div class="keyvalue-item">
                    <div class="key">From</div>
                    <span>{{ item["rata"] }}</span>
                
                  </div>
                  <div class="keyvalue-item ut-flex ut-colcen">
                    <div class="key">To</div>
                  
                    <span>{{ item["rata"] }}</span>
                
                  </div>
                </div> -->
                <span>{{ item["rata"] }}</span>
            </td>
            <td v-bind="tdcon('share')">
              
                <span>{{ item["share"] }}</span>
           
            </td>
            <td v-bind="tdcon('recoupables')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="`exclude-${item['product_account_id']}`"
                    :id="`exclude-${item['product_account_id']}`"
                    :checked="item['allow_cost_split_flag'] == '1'"
                    @click="(e) => onProductExclude(e, item,'allow_cost_split_flag')"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('exclude')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="`exclude-${item['product_account_id']}`"
                    :id="`exclude-${item['product_account_id']}`"
                    :checked="item['exclude'] == '1'"
                    @click="(e) => onProductExclude(e, item,'exclude')"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            
            <td v-bind="tdcon('royalty_info1')">
                <div class="keyvalue-container">
                  <div class="ut-flex" style="flex-direction: column">
                    <!-- <div class="key">From</div> -->
                    <span v-for="(info,index)  in getRoyaltyInfoArray(item['royalty_options_info'])" :key="index"> —  {{info}}</span>
                    <!-- <span>{{item['royalty_options_info']}}</span>
                    <span>{{item['royalty_options_info']}}</span> -->
                
                  </div>
                  <div class="keyvalue-item ut-flex ut-colcen">
                    <!-- <div class="key">To</div> -->
                  
                 
                
                  </div>
                </div>
                <!-- <span class="ut-colcen" style="min-width: 35px">
                    {{item['royalty_options_info']}}
                </span> -->
              
            </td>
            <!-- <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteAccount(item)"
                  alt="Delete Related Contact"
                  title="Delete Related Contact"
                />
              </div>
            </td> -->
          </tr>
        </template>
      </NTable>


    </div>
  </DBox>
</template>

<script>
import { openMailWindow } from "@/utility";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import TextField from "@plugins/text-field/text-field";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { royaltyAccountsListLDTRoutes, royaltyContractsListLDTRoutes } from '../../../royalty/router/routes';


export default {
  components: {
    TextField,
    NTable,
    DBox,
  },
  props: {
    selectedProductDetails: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 2,
        headerHeight: 32,
        rowHeight: "auto",
        fullHeight: true,
        footer: false,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("contract", { f: 0.9 }),
        createTableHeader("royalty_account",{ f:0.75}),
        createTableHeader("rata", { mw: 50,ta: "center" }),
        createTableHeader("share", { mw: 60, ta: "center" }),
        createTableHeader("recoupables", {  mw: 90,ta: "center" }),
        createTableHeader("exclude", {  mw: 60,ta: "center" }),
        createTableHeader("royalty_info1", { ta:'left'}),
       
      ];
    },
    list: function () {
        //Object.value()
      console.log({'royalty.vue:169 this.selectedProductDetails.contract' : this.selectedProductDetails.contract});
      console.log({'royalty.vue:169 this.selectedProductDetails' : this.selectedProductDetails});

      return this.selectedProductDetails.contract.contracts || [];
    },
  },
  methods: {
    onContractClick:function(item){
      console.log(item)
      this.$router.push({
        name: royaltyContractsListLDTRoutes.names.tab,
        params: {
          contract_id: item.contract_id,
          tab: "overview"
        }
      });
    
    },
    onAccountClick:function(item){
       console.log(item)
       //royaltyAccountsListLDTRoutes
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: item.royalty_account_id,
          tab: "overview"
        }
      });
    },
    getRoyaltyInfoArray:function(info){
      
      return info.split("\n");
    
    },
    onTextInputBlur: function (event, name, item) {
      console.log(event);
      const value = event.value;
      this.$emit("changed", { name, value, item });
    },
    onContactNameClick: function (contact) {
      this.$emit("contact_selected", contact);
    },
    onMail: function (contact) {
      openMailWindow(`mailto: ${contact.email1}`);
    },
    addContactRelationClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id: this.external_id,
          external_table: this.external_table,
        },
      });
    },
    addAccountClick:function(){
      
       this.$router.push({
        ...this.$route,
        query: {
          modal: "add_product_account",
          external_id:this.selectedProductDetails.product.product_id
        },
      });
    },
    onDeleteAccount: function (item) {
      this.$emit("delete", item);
    },
    onProductExclude: function (e, item,name) {
       console.log("WERE",item)
        
        if(e.target.checked){
          const payload={ name:name, value:1, kVal:item.contract_pos_id }
          this.$emit("changed", payload);
        }else{
          const payload={ name:name, value:0, kVal:item.contract_pos_id }
          this.$emit("changed", payload);
        }
     
      // if (e.target.selected) {
       
      //   this.$emit("changed", { name, value, item });
      // }
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-royalty{
  .dt-ntable {
    .ut-flex{
      align-items:start
    }
    
    td,
    th {
        flex: 1;
        padding: 0px;
        box-sizing: border-box;
    }
  }
}
</style>
